import { Group, Text } from '@mantine/core';

/** The landing page's mark: a book and a labelled bin on an enamel board. */
export function Wordmark() {
  return (
    <Group gap={8} wrap="nowrap">
      <svg width="24" height="24" viewBox="0 0 32 32" aria-hidden="true">
        <rect width="32" height="32" rx="7" fill="#15222e" />
        <rect x="7" y="10" width="7" height="12" rx="1" fill="#e6ebee" />
        <rect x="16" y="14" width="9" height="8" rx="1" fill="#ffc933" />
        <rect x="5" y="23" width="22" height="2.5" rx="1" fill="#6f9cc4" />
      </svg>
      <Text fw={700} size="lg">
        Asset Shelf
      </Text>
    </Group>
  );
}
